import { useSelector } from "react-redux";
import {
   normalizePermission,
   normalizePermissions,
   selectUserPermissions,
} from "../../utils/permissions";

const usePermission = () => {
   const permissions = useSelector((state) =>
      normalizePermissions(selectUserPermissions(state)),
   );

   const can = (permission) => {
      if (!permission) return false;
      return permissions.includes(normalizePermission(permission));
   };

   const canAny = (permissionList = []) => {
      return permissionList.some((permission) =>
         permissions.includes(normalizePermission(permission)),
      );
   };

   const canAll = (permissionList = []) => {
      return permissionList.every((permission) =>
         permissions.includes(normalizePermission(permission)),
      );
   };

   return {
      permissions,
      permissionsLoading: false,
      can,
      canAny,
      canAll,
   };
};

export default usePermission;
